import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { useQueryClient } from "@tanstack/react-query";
import { cacheAction, cacheOwner, idbPersister } from "../../queryPersister";

/**
 * Keeps the persisted query cache to one account (queryPersister.ts, rule 1). Once Clerk says who's signed in:
 * the same account keeps its cache; a different account, or a sign-out, wipes it from memory and disk. The
 * wipe resets the queries rather than clearing them, so whatever is on screen refetches as the new account
 * (or as nobody). Renders nothing; mounted once, inside ClerkProvider and the query client.
 */
export function CacheOwnerGuard() {
  const { isLoaded, userId } = useAuth();
  const queryClient = useQueryClient();
  useEffect(() => {
    const action = cacheAction({ isLoaded, userId: userId ?? null }, cacheOwner.get());
    if (action === "adopt" && userId) cacheOwner.set(userId);
    if (action === "wipe" || action === "wipe-and-adopt") {
      void idbPersister.removeClient();
      if (action === "wipe-and-adopt" && userId) cacheOwner.set(userId);
      else cacheOwner.clear();
      void queryClient.resetQueries();
    }
  }, [isLoaded, userId, queryClient]);
  return null;
}
